import React, { useCallback } from 'react';
import Modal from '@/common/components/Modal/index';
import modalStyles from '@/common/styles/modal-form-primary.less';
import Button from '@mui/material/Button';
import { FinalDispositionForm } from '@/common/containers/Forms/index';
import { Notification } from '@/common/utils/index';
import { useCurrentDecedentId } from '@/app/providers/DecedentProvider';
import { useTranslation } from 'react-i18next';
import { useSubmitAnswersMutation } from '@/entities/question';

const FinalDisposition = ({
  form,
  refreshTask,
  hideSaleProceeds = false,
  ...props
}) => {
  const { t } = useTranslation();
  const decedentId = useCurrentDecedentId();
  const { question, answers = [], taskStepId } = form || {};
  const submitAnswersMutation = useSubmitAnswersMutation();
  const loading = submitAnswersMutation.isPending;

  const onSubmit = useCallback(
    async (form) => {
      const action = !answers.length ? 'create' : 'update';

      const payload = {
        taskStepId,
        action,
        value: form,
      };
      if (answers.length) {
        payload.answerId = answers[0].id;
      }

      try {
        await submitAnswersMutation.mutateAsync({
          answers: [payload],
          decedentId,
          section: 'main',
          sectionType: 'Task',
        });
      } catch (e) {
        return;
      }

      Notification.success(t('Final Disposition is saved'));

      props.onClose();
      refreshTask();
    },
    [
      answers,
      decedentId,
      props,
      refreshTask,
      submitAnswersMutation,
      t,
      taskStepId,
    ]
  );

  return (
    <Modal className={modalStyles.modal} {...props} overlayOnClose={false}>
      <div className={modalStyles.modalHeader}>
        <h3>{t('Final disposition')}</h3>
      </div>
      <div className={modalStyles.modalForm}>
        <div className={modalStyles.modalBody}>
          <FinalDispositionForm
            question={question}
            answers={answers}
            hideSaleProceeds={hideSaleProceeds}
            id="finalDisposition"
            onSubmit={onSubmit}
          />
        </div>
        <div className={modalStyles.modalFooter}>
          <div className={modalStyles.modalFooterBtns}>
            <Button
              variant="outlined"
              color="secondary"
              onClick={props.onClose}
              disabled={loading}
            >
              {t('Cancel')}
            </Button>
            <Button
              type="submit"
              variant="contained"
              form="finalDisposition"
              loading={loading}
            >
              {t('Save')}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default FinalDisposition;
